import React from 'react';
import { FaRegIdBadge } from 'react-icons/fa';
import styles from './AuthLayout.module.css';

export default function AuthLayout({ title, subtitle, tone = 'default', brandIcon, credit, children }) {
  return (
    <div className={styles.root}>
      <div className={styles.backdrop} aria-hidden />
      <div className={styles.card}>
        <header className={styles.header}>
          <div className={styles.brandMark} aria-hidden>
            {brandIcon ?? <FaRegIdBadge />}
          </div>
          <h1 className={[styles.title, tone === 'danger' && styles.titleDanger].filter(Boolean).join(' ')}>
            {title}
          </h1>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </header>
        {children}
        {credit ? <div className={styles.credit}>{credit}</div> : null}
      </div>
    </div>
  );
}

export function AuthFields({ children }) {
  return <div className={styles.fields}>{children}</div>;
}

export function AuthFooter({ children }) {
  return <div className={styles.footer}>{children}</div>;
}

export function AuthSubmitRow({ children }) {
  return <div className={styles.submitRow}>{children}</div>;
}
